import { render, staticRenderFns } from "./RessifApexDonutChart.vue?vue&type=template&id=2db9afa6&scoped=true&"
import script from "./RessifApexDonutChart.vue?vue&type=script&lang=ts&"
export * from "./RessifApexDonutChart.vue?vue&type=script&lang=ts&"
import style0 from "./RessifApexDonutChart.vue?vue&type=style&index=0&id=2db9afa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db9afa6",
  null
  
)

export default component.exports